import { SVGProps } from 'react';

export const FadeToBlackIcon = ({ className }: SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    fill="currentColor"
    stroke="currentColor"
    strokeWidth={0}
    viewBox="0 0 6.35 6.35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 0.52296551,4.6595606 V 1.6829981 H 5.8146321 v 0.00465 L 0.52348231,4.6595606 Z"
    />
    <path
      d="M 5.8141588,1.6867187 V 4.6632812 H 0.52249218 v -0.00465 L 5.8136421,1.6867187 Z"
      fill='black'
    />
  </svg>
);
